// extracted by mini-css-extract-plugin
export default {"chartContainer":"SignalsBacktestTechnicalsPlot_chartContainer__AdB7y","chartWrapper":"SignalsBacktestTechnicalsPlot_chartWrapper__MN1J0"};